import { Paper, styled } from '@mui/material';
import { ERROR_500 } from 'common/config/api';

const PREFIX = 'StatusCard';

export const classes = {
  card: `${PREFIX}-card`,
  title: `${PREFIX}-title`,
  divider: `${PREFIX}-divider`,
  value: `${PREFIX}-value`,
  skeleton: `${PREFIX}-skeleton`,
};

export const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.card}`]: {
    display: 'inline-block',
    margin: theme.spacing(1),
    minWidth: 150,
    padding: theme.spacing(1),
    textAlign: 'center',
  },

  [`& .${classes.title}`]: {
    fontSize: theme.spacing(1.75),
    textTransform: 'uppercase',
  },

  [`& .${classes.divider}`]: {
    backgroundColor: theme.palette.secondary.main,
    height: 2,
    margin: `${theme.spacing(0.5)}px auto`,
  },

  [`& .${classes.value}`]: (props: { value: number }) => ({
    fontWeight: 600,
    fontSize: theme.spacing(2.25),
    marginBottom: 0,
    color: props.value >= Number(ERROR_500) ? theme.palette.error?.main : undefined,
  }),

  [`& .${classes.skeleton}`]: {
    height: 21,
  },
}));